import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth, errMsg } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { googleExchange } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = location.hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    const path = location.pathname || "/";
    (async () => {
      try {
        if (!sid) throw new Error("no session");
        const user = await googleExchange(sid);
        toast.success(`Bienvenue${user.name ? ", " + user.name.split(" ")[0] : ""} !`);
        navigate(path + location.search, { replace: true });
      } catch (e) {
        toast.error(errMsg(e, "Connexion Google impossible"));
        navigate("/connexion", { replace: true });
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
